import { ServiceData } from '../service';
import db from '../index';
import { entityServiceFactory } from '../entityServiceFactory';

export interface InspectionTemplatesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<InspectionTemplatesServiceData>(
    db,
    'inspectionTemplatesService'
  );

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
